import React from "react";

const FooterSection: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-gray-300 py-6 text-center text-sm">
      <p>
        © {new Date().getFullYear()} Tadwiro by <strong>Ayser World</strong> — All rights reserved.
      </p>
      <p className="mt-2">
        <a href="https://firojalamkhan.com" className="text-blue-400 hover:underline">
          Visit My Portfolio
        </a>
      </p>
    </footer>
  );
};

export default FooterSection;